import HopsXingOneConfigureFetchRuntimeMixin from './mixin.runtime-common';

class HopsXingOneConfigureFetchBrowserMixin extends HopsXingOneConfigureFetchRuntimeMixin {}

export default HopsXingOneConfigureFetchBrowserMixin;
